<div class="position-relative" style="width: 100%; height: 100%;">
  <router-outlet>
    <app-header></app-header>
  </router-outlet>
  <ngx-ui-loader [loaderId]="'applicationLoader'"></ngx-ui-loader>
</div>

